export const routes = (parentName) => {
  return [
    {
      path: 'managers',
      component: () => import('./Index.vue'),
      children: [
        {
          path: '',
          name: `${parentName}-Managers`,
          component: () => import('./List.vue'),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: 'new',
          name: `${parentName}-Managers-New`,
          component: () => import('./Upsert.vue'),
        },
        {
          path: ':id',
          name: parentName + '-' + 'Managers-View',
          component: () => import('./View.vue'),
        },
        {
          path: ':id/edit',
          name: parentName + '-' + 'Managers-Edit',
          component: () => import('./Upsert.vue'),
        },
      ],
    },
  ];
};
